<template>
  <q-dialog
    :model-value="setting && setting.status === 'ON'"
    no-backdrop-dismiss
    no-esc-dismiss
    no-route-dismiss
    maximized
    transition-show="slide-up"
  >
    <div class="system-dialog maint-window">
      <q-card class="q-py-xl q-px-md">
        <mira-logo
          width="125px"
          height="32px"
          type="horizontal"
          class="q-mb-xl"
        />

        <q-item-label class="text-h4 q-pb-md sys-title">
          Undergoing Maintenance
        </q-item-label>

        <q-item-label v-if="setting.message" class="text-h6 sys-descr">
          {{ setting.message }}
        </q-item-label>

        <div class="q-mt-xl flex justify-center">
          <q-btn
            no-caps
            label="Check For Updates"
            icon-right="update"
            color="blue-grey-7"
            :loading="checkingForUpdates"
            @click="checkForUpdates"
          />

          <q-btn
            flat
            no-caps
            label="Help"
            icon-right="mdi-chat-processing"
            class="q-ml-sm"
            color="blue-7"
            :loading="checkingForUpdates"
            @click="$intercom.show()"
          />
        </div>

        <q-spinner-gears
          size="20em"
          color="grey-3"
          class="spinner absolute-top-right no-pointer-events"
        />
      </q-card>
    </div>
  </q-dialog>
</template>

<script>
/**
 * Will show maintenance dialog
 * if triggering an API endpoint returns the status code
 */
export default {
  data () {
    return {
      checkingForUpdates: false
    }
  },
  computed: {
    setting () {
      return this.$store.getters.getMaintenance
    }
  },
  methods: {
    async checkForUpdates () {
      this.checkingForUpdates = true
      const { status } = await this.$get('v1/system/checkForUpdates')
      this.checkingForUpdates = false
      if (!status || status === 'maintenance') {
        this.$q.dialog({
          title: 'Still Going...',
          message: 'Our maintenance break hasn\'t finished yet. Please check back again soon!',
          persistent: true
        })
      }
      else {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.maint-window {
  .q-card {
    max-width: 600px;

    .sys-descr {
      max-width: 450px;
    }
  }

  .spinner {
    right: -140px;
    top: -140px;
  }
}
</style>
